var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4531_11725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.416992C11.2771 0.416992 12.3872 1.13501 12.9473 2.19141L13.1084 2.49512L13.4375 2.39453C14.5805 2.04355 15.8733 2.32057 16.7764 3.22363C17.6794 4.1267 17.9565 5.41949 17.6055 6.5625L17.5049 6.8916L17.8086 7.05273C18.865 7.61279 19.583 8.72288 19.583 10C19.583 11.2771 18.865 12.3872 17.8086 12.9473L17.5049 13.1084L17.6055 13.4375C17.9564 14.5805 17.6794 15.8733 16.7764 16.7764C15.8733 17.6794 14.5805 17.9564 13.4375 17.6055L13.1084 17.5049L12.9473 17.8086C12.3872 18.865 11.2771 19.583 10 19.583C8.72288 19.583 7.61279 18.865 7.05273 17.8086L6.8916 17.5049L6.5625 17.6055C5.41949 17.9565 4.1267 17.6794 3.22363 16.7764C2.32057 15.8733 2.04355 14.5805 2.39453 13.4375L2.49512 13.1084L2.19141 12.9473C1.135 12.3872 0.416992 11.2771 0.416992 10C0.416992 8.72288 1.135 7.61279 2.19141 7.05273L2.49512 6.8916L2.39453 6.5625C2.04356 5.41949 2.32058 4.12669 3.22363 3.22363C4.12669 2.32058 5.41949 2.04356 6.5625 2.39453L6.8916 2.49512L7.05273 2.19141C7.61279 1.13499 8.72288 0.416992 10 0.416992Z",
    fill: "#F26A1C",
    stroke: "white",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5519 6.8419C12.8868 6.38138 13.5317 6.27928 13.9923 6.61404C14.4528 6.94896 14.5549 7.59387 14.2202 8.05447L10.0535 13.7836C9.87611 14.0275 9.60059 14.1816 9.29992 14.2052C8.99927 14.2288 8.70343 14.1198 8.49018 13.9065L5.88602 11.3024C5.48332 10.8996 5.4833 10.2467 5.88602 9.84402C6.28874 9.44133 6.94163 9.44133 7.34435 9.84402L9.09484 11.5945L12.5519 6.8419Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4531_11725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedAccountIcon);
export default __webpack_public_path__ + "static/media/verified-account-icon.137af83fdd7a825914462d0daa2dad1f.svg";
export { ForwardRef as ReactComponent };